module.exports = __webpack_public_path__ + "img/ic-qrcode.0949e420.svg";